import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function referencesReducer() {
    return combineReducers({
        EDocInfoOut_List2NDFL_PO: createItemReducer("References", "EDocInfoOut.List2NDFL_PO", false),
        EDocInfoOut_GetForViewPO: createItemReducer("References", "EDocInfoOut.GetForViewPO", false),
        EDocInfoOut_GetForLoadPO: createItemReducer("References", "EDocInfoOut.GetForLoadPO", false),
        EDocInfoOut_New2NDFL_PO: createItemReducer("References", "EDocInfoOut.New2NDFL_PO", false),
        EDocInfoOut_SelYear2NDFL_PO: createItemReducer("References", "EDocInfoOut.SelYear2NDFL_PO", false),
        EDocInfoOut_InfoPagePO: createItemReducer("References", "EDocInfoOut.InfoPagePO", false),
        EDocInfoOut_GetForLoadListPO: createItemReducer("References", "EDocInfoOut.GetForLoadListPO", false),
        EDocInfoOut_GetForLoadFilePO: createItemReducer("References", "EDocInfoOut.GetForLoadFilePO", false),

        // Новые справки
        EDocInfoOut_ListForPO: createItemReducer("References", "EDocInfoOut.ListForPO", false),
        EDocInfoOut_ListForPO_Params : createItemReducerParams("References", "EDocInfoOut.ListForPO"),
        EDocInfoOut_ListForPO_Del: createItemReducer("References", "EDocInfoOut.ListForPO_Del", false),
        EDocInfoOut_RequestPO: createItemReducer("References", "EDocInfoOut.RequestPO", false),
        EDoc_ListForPO: createItemReducer("References", "EDoc.ListForPO", false),
        EDocInfoOutType_SelectOneReq: createItemReducer("References", "EDocInfoOutType.SelectOneReq", false),
        EDocInfoOut_NewFromPO: createItemReducer("References", "EDocInfoOut.NewFromPO", false),
        EDocInfoOut_NewFromPO_Params : createItemReducerParams("References", "EDocInfoOut.NewFromPO"),
        EDocInfoOut_GetInfoOutTempl: createItemReducer("References", "EDocInfoOut.GetInfoOutTempl", false),
        EDocInfoOut_GetInfoOutData: createItemReducer("References", "EDocInfoOut.GetInfoOutData", false)
    });
}